module.exports = __webpack_public_path__ + "img/src/components/Home/SliderAnimation/carbanner.jpg?63e6d908";